
<div class="row">
    <div class="col-12">

        <div class="header">
            
            <div *ngIf="!attributeId" class="modal-title">
                Добавить новую группу атрибутов
            </div>
            
            <div *ngIf="attributeId" class="modal-title">
                Редактировать группу атрибутов
            </div>

            <div class="btn">
                <!-- btn -->
                <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                    <span aria-hidden="true">&times;</span>
                </button> -->
                <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                    <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                    [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                </button>
            </div>

        </div>

    </div>
</div>

<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <!-- <div *ngIf="permissionAccess.check('REFERENCES_ORGANIZATIONS') && editData && editData.org_id">
            <div class="form-group">
                <label class="filter-label" for="org_id"> 11 </label>
                <ng-select 
                id="org_id" 
                class="custom" 
                clearAllText="{{ 'CLEAR' | translate }}"
                notFoundText="{{ 'NO_DATA' | translate }}" 
                bindLabel="name" 
                bindValue="id"
                formControlName="org_id"
                (search)="getOrganizations($event.term)"
                placeholder="{{ 'ORGANIZATION.CHOOSE_ORGANIZATION.' | translate }}"
                [multiple]="false" 
                [items]="organizations">
                </ng-select>
            </div>
        </div> -->


        <div class="row">
            <div class="col-12">
                <ff-input-lang
                    label="Наименование группы"
                    hint="Укажите название атрибута на всех языках"
                    fieldId="name"
                    fieldName="name"
                    fieldType="text"
                    [clearField]="ffInputLangParams.name.clearField"
                    [required]="ffInputLangParams.name.required"
                    [inputValue]="groupName"
                    (changeValue)="eventFnFF('name', $event)">
                </ff-input-lang>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer btn-box">
    <button *ngIf="!attributeId" type="button" class="btn btn-primary btn-sm" (click)="onCreate()"     [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button>
    <button *ngIf="attributeId"  type="button" class="btn btn-primary btn-sm" (click)="onUpdate()"     [disabled]="form.invalid || !ffInputLang.valid ">{{ 'SAVE'| translate}}</button>
    <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
</div>